import { RefObject, useEffect, useState } from 'react';

interface UseHorizontalScrollChevronsParams {
  scrollRef: RefObject<HTMLDivElement>;
  topScrollRef?: RefObject<HTMLDivElement>;
  dependencies?: any[];
}

// Todo: WEB-1022. Integrate this later. https://app.asana.com/1/41213529744312/task/1211787530791625/comment/1212254369654670?focus=true
export const useHorizontalScrollChevrons = ({
  scrollRef,
  topScrollRef,
  dependencies = [],
}: UseHorizontalScrollChevronsParams) => {
  const [showLeftChevron, setShowLeftChevron] = useState(false);
  const [showRightChevron, setShowRightChevron] = useState(false);

  useEffect(() => {
    const scrollWrapper: HTMLDivElement  = scrollRef.current;
    const topScroll: HTMLDivElement = topScrollRef?.current;

    if (!scrollWrapper) {
      console.error('❌ Scroll element not found');
      return;
    }

    const handleScroll = () => {
      if (topScroll) {
        topScroll.scrollLeft = scrollWrapper.scrollLeft;
      }

      if (scrollWrapper.scrollLeft === 0) {
        setShowLeftChevron(false);
      } else {
        setShowLeftChevron(true);
      }

      if (
        scrollWrapper.scrollLeft + scrollWrapper.clientWidth >=
        scrollWrapper.scrollWidth
      ) {
        setShowRightChevron(false);
      } else {
        setShowRightChevron(true);
      }
    };

    const handleTopScroll = () => {
      if (!topScroll) {
        return;
      }

      scrollWrapper.scrollLeft = topScroll.scrollLeft;
    };

    scrollWrapper.addEventListener('scroll', handleScroll);

    if (topScroll) {
      topScroll.addEventListener('scroll', handleTopScroll);
    }

    handleScroll();

    return () => {
      scrollWrapper.removeEventListener('scroll', handleScroll);

      if (topScroll) {
        topScroll.removeEventListener('scroll', handleTopScroll);
      }
    };
  }, dependencies);

  return { showLeftChevron, showRightChevron };
};